export type AcaoLoteLancamento = 'baixar' | 'cancelar' | 'excluir';

type LinhaOuId = string | number | { id?: string | number | null };

export const MENSAGEM_SEM_LANCAMENTOS_NA_TABELA = 'Não existem lançamentos na tabela para esta ação.';

// A ação em lote age sobre as linhas que a tabela está exibindo (período, status, tipo, filial,
// filtros avançados e busca já aplicados), e não sobre uma nova consulta montada no servidor.
export const idsDasLinhasExibidas = (linhas: ReadonlyArray<LinhaOuId>): string[] => {
    const ids = linhas
        .map(linha => (typeof linha === 'object' && linha !== null ? linha.id : linha))
        .filter((id): id is string | number => id !== null && id !== undefined && id !== '')
        .map(String);
    return Array.from(new Set(ids));
};

export const mensagemSemLancamentosParaAcao = (acao: AcaoLoteLancamento, quantidadeExibida: number): string => {
    if (quantidadeExibida === 0) return MENSAGEM_SEM_LANCAMENTOS_NA_TABELA;

    const um = quantidadeExibida === 1;
    switch (acao) {
        case 'cancelar':
            return um
                ? 'O lançamento exibido não está resolvido. Cancelar só se aplica a lançamentos resolvidos (pagos).'
                : `Nenhum dos ${quantidadeExibida} lançamentos exibidos está resolvido. Cancelar só se aplica a lançamentos resolvidos (pagos).`;
        case 'baixar':
            return um
                ? 'O lançamento exibido já está resolvido.'
                : `Os ${quantidadeExibida} lançamentos exibidos já estão resolvidos.`;
        case 'excluir':
            return um
                ? 'O lançamento exibido foi gerado por manutenção do veículo. Para excluí-lo, use o cadastro de manutenção do veículo.'
                : 'Os lançamentos exibidos foram gerados por manutenção do veículo. Para excluí-los, use o cadastro de manutenção do veículo.';
    }
};
